import { ellipsis } from "polished";
import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.875rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  border-radius: 1.25rem;
  padding: 1.875rem;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.11);

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    padding: 5.625rem 1.875rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Tagline = Styled.p`
  max-width: 51rem;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 1.875rem;
  letter-spacing: -0.2px;
  text-align: center;
  margin: 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: 30rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: 44.375rem;
  }
`;

export const IllustrationWrapper = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 100%;
`;

export const IllustrationContainer = Styled.div`
  height: 1.25rem;
  margin: 0px 0.781rem 1.875rem 0.781rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    margin: 0px 1.262rem 1.875rem;
    height: 1.875rem;
  }
`;

export const Illustration = Styled.img`
  width: 100%;
  height: 100%;
`;

export const Form = Styled.form`
  width: 100%;

  ${(props) => props.theme.breakpoints.up("medium")} {
    width: 31.25rem;
    margin-top: 1.25rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    width: 43.75rem;
    margin-top: 1.25rem;
  }
`;

export const FieldGroupContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-items: center;
  gap: 1rem;
  margin-bottom: 1.875rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 2rem;
  }
`;

export const FieldGroup = Styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.625rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    min-width: 14.625rem;
    flex: 0.5;
  }
`;

export const Label = Styled.label`
  ${ellipsis()}
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.125rem;
  letter-spacing: -0.1px;
  color: inherit;
`;

export const Input = Styled.input`
  display: block;
  width: 100%;
  height: 2.75rem;

  padding: 0 1rem;
  background-color: #f7f7f7;
  border: 1px solid transparent;
  border-radius: 0.5rem;
  outline: none;

    font-size: 1rem;
  font-weight: normal;
  line-height: 2.75rem;

  &:focus {
    outline: none;
    border: 1px solid #030303;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
   font-size: 1.125rem;
   line-height: 3.125rem;
   height: 3.125rem;
  }
`;

export const SuccessContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 1.875rem;
  margin-top: 1.25rem;
`;

export const SuccessDescription = Styled.p`
  font-size: 1rem;
  font-weight: 400;
  color: inherit;
  line-height: 1.25rem;
  margin: 0;


  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.25rem;
    line-height: 1.718rem;
  }
`;

export const Error = Styled.div`
  display: inline-block;
  padding: 0.5rem;
  margin-top: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 0.625rem;
  background: #d32828;
  color: #FAFAFA;
  border-radius: 0.25rem;
`;
